import BaseHeading from './BaseHeading'
import type { ReactNode } from 'react'

interface PropsType {
  children: ReactNode
}

const MiscHeading = (props: PropsType) => <BaseHeading className="border-l-5 border-l-gray-500">{props.children}</BaseHeading>

export default MiscHeading
